"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const CheckboxIcon_1 = require("../../../assets/svg-components/CheckboxIcon");
const Typography_1 = require("../Typography");
const style = __importStar(require("./style"));
const Checkbox = ({ name, label, checked, onClick, onChange, value, marginRight, disabled = false, results, isFilter }) => {
    const [localChecked, setLocalChecked] = (0, react_1.useState)(checked);
    const _onChange = (e) => {
        setLocalChecked(!localChecked);
        onChange && onChange(e);
    };
    (0, react_1.useEffect)(() => {
        setLocalChecked(checked);
    }, [checked]);
    return (react_1.default.createElement(style.Wrapper, { marginRight: marginRight },
        react_1.default.createElement(style.Label, { disabled: disabled },
            react_1.default.createElement(style.Checkbox, { tabIndex: 0, role: "checkbox", "aria-checked": localChecked, "aria-labelledby": name, disabled: disabled, checked: localChecked, onKeyDown: e => {
                    if (e.key === ' ' || e.key === 'Enter') {
                        e.preventDefault();
                        setLocalChecked(!localChecked);
                        onChange === null || onChange === void 0 ? void 0 : onChange({ target: { checked: !localChecked, name } });
                    }
                } },
                react_1.default.createElement(CheckboxIcon_1.CheckboxIcon, null)),
            react_1.default.createElement(style.Input, { type: "checkbox", name: name, checked: localChecked, onClick: onClick, onChange: _onChange, value: value, required: true, tabIndex: -1, disabled: disabled }),
            label && (react_1.default.createElement(style.LabelContainer, { isFilter: isFilter },
                label,
                results >= 0 && react_1.default.createElement(style.ResultsText, { type: Typography_1.Types.BODY_2 },
                    "(",
                    results,
                    ")"))))));
};
exports.default = Checkbox;
